<template>
  <v-dialog persistent max-width="80%" min-height="80%">
    <v-card class="pa-4">
      <v-card-title class="d-flex justify-space-between align-center">
        New Campaign
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          icon="mdi-close"
          @click="() => $emit('update:modelValue', false)"
          class="close-button"
        />
      </v-card-title>

      <v-card-text class="pa-0 ma-0">
        <CampaignCreationStepper
          ref="stepper"
          @submit="$emit('create', $event)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
    
    <script>
import CampaignCreationStepper from "./CampaignCreationStepper.vue";

export default {
  name: "CampaignCreationDialog",
  components: {
    CampaignCreationStepper,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "create"],
  data() {
    return {
      createdPlacement: null,
    };
  },
  computed: {},

  watch: {},

  created() {
    console.log("Dialog created");
  },
  methods: {
    setPlacement(placement) {
      this.createdPlacement = placement;
    },
  },
};
</script>